import { CircularProgress, InputAdornment, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import PurchaseService from "services/purchases";
import SaleService from "services/sales";

const formatBRL = (valor) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(valor) || 0
  );

/**
 * Campo para vincular um pedido (compra ou venda) a uma conta a pagar/receber.
 * O usuário digita o nº do pedido; ao sair do campo o pedido é buscado e o
 * _id é gravado em formik.values[field] ("purchase" ou "sale").
 */
export default function VincularPedido({
  formik,
  tipo = "compra",
  disabled = false,
  numPedidoInicial = "",
}) {
  const field = tipo === "compra" ? "purchase" : "sale";
  const [numPedido, setNumPedido] = useState(numPedidoInicial || "");
  const [buscando, setBuscando] = useState(false);
  const [mensagem, setMensagem] = useState({ erro: false, texto: "" });

  useEffect(() => {
    setNumPedido(numPedidoInicial || "");
  }, [numPedidoInicial]);

  const buscar = async () => {
    const num = String(numPedido).trim();

    if (!num) {
      formik.setFieldValue(field, "");
      setMensagem({ erro: false, texto: "" });
      return;
    }

    setBuscando(true);
    try {
      const Service = tipo === "compra" ? PurchaseService : SaleService;
      const pedidos = await Service.filter({ numPedido: num });
      const pedido = Array.isArray(pedidos) ? pedidos[0] : null;

      if (!pedido) {
        formik.setFieldValue(field, "");
        setMensagem({ erro: true, texto: `Pedido ${num} não encontrado.` });
        return;
      }

      formik.setFieldValue(field, pedido._id);
      if (!formik.values.partidaContabil) {
        formik.setFieldValue("partidaContabil", pedido.numPedido);
      }

      const pessoa =
        tipo === "compra"
          ? pedido.supplier?.razaoSocial || pedido.supplier?.nomeFantasia
          : pedido.customer?.razaoSocial || pedido.customer?.nomeFantasia;
      setMensagem({
        erro: false,
        texto: `Vinculado: pedido ${pedido.numPedido}${
          pessoa ? ` – ${pessoa}` : ""
        } – ${formatBRL(pedido.totalFinal ?? pedido.valorTotal)}`,
      });
    } catch (error) {
      console.log(error);
      setMensagem({ erro: true, texto: "Erro ao buscar o pedido." });
    } finally {
      setBuscando(false);
    }
  };

  return (
    <TextField
      id={`vincular-${field}`}
      label={`Pedido de ${tipo === "compra" ? "Compra" : "Venda"} vinculado (nº)`}
      value={numPedido}
      onChange={(e) => setNumPedido(e.target.value.replace(/\D/g, ""))}
      onBlur={buscar}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          buscar();
        }
      }}
      disabled={disabled}
      error={mensagem.erro}
      helperText={
        mensagem.texto || "Digite o nº do pedido. Deixe vazio para desvincular."
      }
      InputLabelProps={{ shrink: true }}
      InputProps={{
        endAdornment: buscando ? (
          <InputAdornment position="end">
            <CircularProgress size={18} />
          </InputAdornment>
        ) : null,
      }}
    />
  );
}
